"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The GetPermissionsRequest model module.
 * @module model/GetPermissionsRequest
 * @version 1.1.3-alpha.1
 */
class GetPermissionsRequest {
  /**
   * Constructs a new <code>GetPermissionsRequest</code>.
   * @alias module:model/GetPermissionsRequest
   */
  constructor() {
    GetPermissionsRequest.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>GetPermissionsRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GetPermissionsRequest} obj Optional instance to populate.
   * @return {module:model/GetPermissionsRequest} The populated <code>GetPermissionsRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GetPermissionsRequest();
      if (data.hasOwnProperty('permissions')) {
        obj['permissions'] = _ApiClient.default.convertToType(data['permissions'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>GetPermissionsRequest</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GetPermissionsRequest</code>.
   */
  static validateJSON(data) {
    // ensure the json data is an array
    if (!Array.isArray(data['permissions'])) {
      throw new Error("Expected the field `permissions` to be an array in the JSON data but got " + data['permissions']);
    }
    return true;
  }
}

/**
 * @member {Array.<String>} permissions
 */
GetPermissionsRequest.prototype['permissions'] = undefined;
var _default = exports.default = GetPermissionsRequest;